/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import ClientForm from './ClientForm';
import { formatDropDownValues } from '../../utils/formatters';

class ClientAutocomplete extends ClientForm {
  constructor(props) {
    super(props);

    // ClientForm joins array data into a string; restore it as an array for multi-select
    if (props.multiple) {
      this.state = {
        ...this.state,
        data: Array.isArray(props.data) ? props.data : [props.data].filter(Boolean),
      };
    }
  }

  render() {
    const { multiple } = this.props;
    const options = this.state.attribute in this.state.structure
      ? this.state.structure[this.state.attribute].map((val) => String(val))
      : [];

    let value = this.state.data || null;
    if (multiple) {
      value = Array.isArray(this.state.data) ? this.state.data : [];
    }

    return (
      <div key={this.state.attribute}>
        {this.state.attribute in this.state.structure && (
          <>
            {!this.props.hideLabel && (
              <InputLabel
                variant="standard"
                htmlFor={this.state.attribute}
                required={this.state.required}
              >
                {this.state.label}
              </InputLabel>
            )}
            <Autocomplete
              id={this.state.attribute}
              multiple={multiple}
              options={options}
              getOptionLabel={(option) => formatDropDownValues(this.state.attribute, option)}
              value={value}
              onChange={(event, newValue) => {
                const { setter, attribute, label } = this.state;
                this.setState({ data: newValue });
                setter(attribute, newValue, label);
              }}
              disabled={this.state.isDisabled || this.props.isDisabled}
              disableClearable={this.state.required}
              isOptionEqualToValue={(option, val) => option === val}
              sx={{ width: this.props.customWidth || 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    'data-testid': this.state.testingId,
                  }}
                />
              )}
            />
          </>
        )}
      </div>
    );
  }
}

export default ClientAutocomplete;
